import {Pagination} from '../pagination.model';
import { TravelExpenseCoefficient } from '../../../../admin/model/travel-expense-coefficient.model';

export class TravelExpenseCoefficientPage extends Pagination {
  content: TravelExpenseCoefficient[] = [];
}
